module.exports = __webpack_public_path__ + "img/feature-3.e015c25e.png";